import React, { Component } from "react";
import {Col, Nav, Row, Tab} from "react-bootstrap";
import NetworkDeviceContentTable from "./NetworkDeviceContentTable";
import {withNamespaces} from "react-i18next";

class NetworkDeviceContentScenarioList extends Component {

    render() {
        const { t, scenarioList, networkDeviceContentList, deviceInfo } = this.props;

        return(
            <React.Fragment>
                <h6>{t('exhibition-scenario')}</h6>
                <Tab.Container id="left-tabs-example" defaultActiveKey="all">
                    <Row>
                        <Col sm={3}>
                            <Nav variant="pills" className="flex-column">
                                <Nav.Item>
                                    <Nav.Link eventKey="all">{ t('all-items') }</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="null">{ t('exhibition-scenario-default') }</Nav.Link>
                                </Nav.Item>
                                { scenarioList?.map((scenario, idx) => {
                                    return (
                                        <Nav.Item key={idx}>
                                            <Nav.Link eventKey={scenario.id}>{scenario.label}</Nav.Link>
                                        </Nav.Item>
                                    );
                                })}
                            </Nav>
                        </Col>
                        <Col sm={9}>
                            <Tab.Content>
                                <Tab.Pane eventKey="all">
                                    <NetworkDeviceContentTable list={networkDeviceContentList} device={deviceInfo}/>
                                </Tab.Pane>
                                <Tab.Pane eventKey="null">
                                    <NetworkDeviceContentTable list={networkDeviceContentList} device={deviceInfo} scenarioId={"no-selected"}/>
                                </Tab.Pane>
                                { scenarioList?.map((scenario, idx) => {
                                    return (
                                        <Tab.Pane key={idx} eventKey={scenario.id}>
                                            <NetworkDeviceContentTable list={networkDeviceContentList} device={deviceInfo} scenarioId={scenario.id}/>
                                        </Tab.Pane>
                                    );
                                })}
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </React.Fragment>
        )
    }
}
export default withNamespaces()(NetworkDeviceContentScenarioList);